  document.addEventListener('DOMContentLoaded', () => {
    const proNewsTabs = document.querySelector('.filterbalk .typenieuws');
    const proNewsTabsArrow = document.querySelector('#rotateRight');
  
    if (!proNewsTabs || !proNewsTabsArrow) return; // Stop als één van de elementen ontbreekt
  
    function updateArrowVisibility() {
      const isScrollable = proNewsTabs.scrollWidth > proNewsTabs.clientWidth;
      proNewsTabsArrow.style.display = isScrollable ? 'inline-flex' : 'none';
    }
  
    function checkScrollPosition() {
      if (proNewsTabs.scrollLeft + proNewsTabs.clientWidth >= proNewsTabs.scrollWidth - 1) {
        proNewsTabsArrow.style.display = 'none';
      } else {
        proNewsTabsArrow.style.display = 'inline-flex';
      }
    }
  
    updateArrowVisibility();
    window.addEventListener('resize', updateArrowVisibility);
    proNewsTabs.addEventListener('scroll', checkScrollPosition);
  });
  